<template>
    <span class="TextAreaEditor">
        <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" v-on:click="ShowEditModal()" class="pointer" /> {{ OldValue }}
        
        <b-modal ref="component-modal" v-bind:title="ModalTitle" @shown="HandleShown()" hide-footer no-close-on-esc no-close-on-backdrop>
            <b-container>
                <b-form @submit="Save">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Old Value:</label>
                                <p>{{ OldValue }}</p>
                                <label>New Value:</label>
                                <textarea rows="20" class="form-control" v-model="NewValue" ref="showfocus" v-bind:required="Required"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>

                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </span>

</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "OldValue",
            "PropertyName",
            "RecordId",
            "EditMode",
            "DataLabel",
            "UpdateMethod",
            "Required",
            "GlobalUpdate",
            "ChartId",
            "HttpMethod"
        ],
        data: function () {
            return {
                NewValue: ""
            };
        },
        methods: {
            ShowEditModal() {
                this.NewValue = this.OldValue;
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            Save(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest(this.HttpMethod == null ? "POST" : this.HttpMethod, this.UpdateMethod, { Id: this.RecordId, [this.PropertyName]: this.NewValue }, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess(response) {
                this.OldValue = this.NewValue;
                this.$refs['component-modal'].hide();
                //Perform Global Updates
                if (this.GlobalUpdate) {
                    this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
                }
            },
            HandleShown() {
                this.$refs.showfocus.focus();
            }
        },
        components: {

        },
        computed: {
            ModalTitle: function () {
                return "Editing " + this.DataLabel;
            },
        }
    }
</script>

<style scoped>
</style>